import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { questions } from './config';
import { ScreeningModuleStore } from 'Core_Pages/Screening/ScreeningModuleStore';
import { StyledCircularProgress } from 'Core_Components/LoadingWrapper/styles';
import ErrorModal from 'Core_Components/ErrorModal/ErrorModal';
import { NeedsWrapper, NeedsProgressBar, StyledBookmark } from './styles';
import { displayDarkStatusBar } from 'Core_Helpers/statusBar';
import { prapareQuestionMap } from './prapareQuestionType';

function AdultPrapareSdoh() {
  const intl = useIntl();
  const screeningStore = ScreeningModuleStore.Instance().Use();
  const screeningTakerStore = screeningStore.ScreeningForm.Use();
  const { control } = useForm();
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const isLoading = screeningTakerStore.IsLoading || screeningStore.IsLoading;
  const hasError = screeningStore.ScreeningHasError;
  const numberOfScreeningsLeft = screeningStore.DueScreenings?.length > 0 ? screeningStore.DueScreenings?.length : 1;
  const currentScreeningIndex = screeningStore.DueScreeningsIndex + 1;

  const onCloseErrorModal = () => screeningStore.acknowledgeError();
  const onAnswer = (question, answer) => {
    const nextQuestion = currentQuestion + 1;
    screeningTakerStore.updateAnswer(question, answer);

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(nextQuestion);
    }

    if (screeningTakerStore.IsValid) {
      screeningTakerStore.complete();
    }
  };

  useEffect(() => {
    displayDarkStatusBar();
  }, []);

  if (isLoading) {
    return <StyledCircularProgress />;
  }

  const Component = prapareQuestionMap[questions[currentQuestion]?.questionType];
  const filteredOptions = questions[currentQuestion]?.options.filter((o) => o.textId !== 'common.skip');

  return (
    <>
      <NeedsWrapper fullScreen open={true} aria-labelledby="screening-title">
        <StyledBookmark>
          {`${currentScreeningIndex} ${intl.formatMessage({ id: 'common.of' })} ${numberOfScreeningsLeft}`}
        </StyledBookmark>
        <NeedsProgressBar variant="determinate" value={currentQuestion * 5} />
        <Typography id="screening-title" component="h1">
          {intl.formatMessage({ id: 'screenings.adult-needs' })}
        </Typography>
        <Component
          control={control}
          text={intl.formatMessage({ id: `${questions[currentQuestion]?.textId}` })}
          answerType={questions[currentQuestion]?.answerType}
          filteredOptions={filteredOptions}
          skipOption={questions[currentQuestion]?.options.filter((o) => o.textId === 'common.skip')[0]}
          onChange={(answer) => {
            const answerOptionGuid = answer.currentTarget?.name;
            onAnswer(questions[currentQuestion]?.name, answerOptionGuid ? answerOptionGuid : answer);
          }}
          {...questions[currentQuestion]}
        />
      </NeedsWrapper>
      <ErrorModal open={hasError} onClose={onCloseErrorModal} />
    </>
  );
}

export default AdultPrapareSdoh;
